import { useState } from 'react'
import { Button } from '@/components/ui/button.jsx'
import { useConsent } from '@/context/ConsentContext.jsx'
import { CookiePreferencesModal } from './CookiePreferencesModal.jsx'

const COOKIE_POLICY_URL = '/politica-de-cookies-visualg-web.pdf'

/**
 * Banner de consentimento de cookies. Aparece enquanto a escolha de analytics está unset.
 * Analytics (Microsoft Clarity) só carrega após "Aceitar" — opt-in exigido pela LGPD e
 * pela Política de Cookies (§8). Cookies essenciais não dependem deste banner.
 */
export function CookieConsentBanner() {
  const { isUnset, acceptAll, rejectAll } = useConsent()
  const [showPreferences, setShowPreferences] = useState(false)

  if (!isUnset) return null

  return (
    <>
      <div
        role="region"
        aria-label="Consentimento de cookies"
        data-cookie-consent-banner
        aria-live="polite"
        className="fixed inset-x-0 bottom-0 z-50 border-t border-border bg-card/95 p-4 shadow-lg backdrop-blur supports-[backdrop-filter]:bg-card/80"
      >
        <div className="mx-auto flex max-w-5xl flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-sm text-muted-foreground">
            Usamos cookies essenciais para o funcionamento da plataforma. Com a sua autorização,
            também usamos cookies para análise de uso (Clarity e Google Analytics) e publicidade (Google e Adsterra),
            incluindo anúncios personalizados do Google. Sem autorização, o Google pode exibir anúncios limitados.
            Você pode escolher cada categoria, aceitar ou recusar. Saiba mais na{' '}
            <a
              href={COOKIE_POLICY_URL}
              target="_blank"
              rel="noreferrer"
              className="font-medium text-primary underline underline-offset-4"
            >
              Política de Cookies
            </a>
            .
          </p>
          <div className="flex shrink-0 flex-wrap gap-2">
            <Button variant="ghost" size="sm" onClick={() => setShowPreferences(true)}>
              Configurar
            </Button>
            <Button variant="outline" size="sm" onClick={rejectAll}>
              Rejeitar
            </Button>
            <Button size="sm" onClick={acceptAll}>
              Aceitar
            </Button>
          </div>
        </div>
      </div>

      {showPreferences && (
        <CookiePreferencesModal onClose={() => setShowPreferences(false)} />
      )}
    </>
  )
}
